import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

/**
 * Legend
 */

const useStyles = makeStyles({
  legendContainer: {
    zIndex: 99999,
    marginTop: 10,
  },
  legend: {
    height: '20px',
    width: '20px',
    marginRight: 10,
  },
});

export default function LegendRRI() {
  const classes = useStyles();

  return (
    <div className={classes.legendContainer}>
      <Paper
        style={{
          opacity: '0.8',
          backgroundColor: '#EAEAEA',
        }}
      >
        <Box p={1}>

          {/* ไม่มีข้อมูล */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#75808d' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> ไม่มีข้อมูล </Typography>
            </Grid>
          </Grid>

          {/* <= 0.1000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#FFFFFF' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> &lt;= 1 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 0.1000 - 50.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#E1F5FE' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 1 - 50 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 50.0000 - 150.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#81D4FA' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 50 - 150 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 150.0000 - 350.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#29B6F6' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 150 - 350 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 350.0000 - 550.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#1976D2' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 350 - 550 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 550.0000 - 750.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#5E35B1' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 550 - 750 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 750.0000 - 1000.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#8E24AA' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 750 - 1000 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 1000.0000 - 1250.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#C2185B' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 1000 - 1250 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 1250.0000 - 1500.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#E53935' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 1250 - 1500 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 1500.0000 - 1800.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#F4511E' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 1500 - 1800 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 1800.0000 - 2100.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#E64A19' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 1800 - 2100 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 2100.0000 - 2400.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#D32F2F' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 2100 - 2400 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 2400.0000 - 2700.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#B71C1C' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 2400 - 2700 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* 2700.0000 - 3000.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#7F0000' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> 2700 - 4000 (m³/s) </Typography>
            </Grid>
          </Grid>

          {/* > 3000.0000 */}
          <Grid container>
            <Grid item>
              <div
                style={{ backgroundColor: '#7F0000' }}
                className={classes.legend}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2"> &gt; 4000 (m³/s) </Typography>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </div>
  );
}